import { type A7FIAInstrumentTS, getInstrumentsTsColumns } from "./columns";
import {
  FilterA7FIAInstrumentTSSchema,
  FilterA7FIAInstrumentTS,
} from "./filter";
import { Table } from "@/pages/a7/Table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const table_name = "a7_fia_instrument_ts";

export const A7FIAInstrumentsTSTable = () => {
  const { t, i18n } = useTranslation(["tables", "common"]);
  const columns = useMemo(() => getInstrumentsTsColumns(t), [t, i18n.language]);

  return (
    <Table<A7FIAInstrumentTS, FilterA7FIAInstrumentTSSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Financial instruments time series",
      })}
      client="a7"
      table_name={table_name}
      columns={columns}
      filter={<FilterA7FIAInstrumentTS client="a7" table_name={table_name} />}
    />
  );
};
